import { render } from "./UnitForm.vue?vue&type=template&id=f8f1ac32"
import script from "./UnitForm.vue?vue&type=script&lang=js"
export * from "./UnitForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__